import LogoImage from "./mozantech.png";
import BackgroundImage from "./background.svg";
export { LogoImage, BackgroundImage };
